<div class="container signupContainer card" *ngIf="progress == 0 || progress == 100">
	<section class="header text-center">
		<h1 class="mb-0 mt-3 font-weight-bold">{{ 'register.welcome' | translate }}</h1>
		<p class="m-0">{{ 'register.signup-desc' | translate }}</p>
	</section>

	<section class="signup" *ngIf="!loggedIn">
		<div class="row text-center my-4 justify-content-center">
			<button color="accent" mat-flat-button style="width: 318px !important" (click)="loggedIn = !loggedIn">
				{{ 'register.create_account' | translate }}
			</button>
		</div>
		<div class="row justify-content-center">
			<div style="width: 318px !important" class="divider">{{ 'register.signup_continue' | translate }}</div>
		</div>
		<div class="row text-center mt-4 justify-content-center">
			<asl-google-signin-button
				text="continue_with"
				type="standard"
				size="large"
				width="318"
			></asl-google-signin-button>
			<button
				type="button"
				(click)="signInWithFB()"
				class="btn btn-info fb-button my-2 d-flex align-items-center"
				style="width: 318px !important"
			>
				<mat-icon class="col-2" svgIcon="facebook"></mat-icon>
				<span class="col-10">{{ 'register.continueFB' | translate }}</span>
			</button>
		</div>
	</section>
	<mat-stepper #stepper linear *ngIf="loggedIn">
		<ng-container>
			<mat-step [stepControl]="firstStepForm">
				<form [formGroup]="firstStepForm">
					<div class="h6 mb-3">{{ 'register.step_1_title' | translate }}</div>
					<div class="form-group">
						<label class="text-dark"
							>{{ 'register.name' | translate }} <span class="label-mandatory">*</span></label
						>
						<input
							type="text"
							formControlName="name"
							class="form-control"
							placeholder="{{ 'register.name' | translate }}"
							[ngClass]="{
								'input-error': firstStepFormControls.name.touched && firstStepFormControls.name.errors
							}"
						/>
						<div *ngIf="firstStepFormControls.name.touched && firstStepFormControls.name.errors">
							<mat-error *ngIf="firstStepFormControls.name.errors.required">{{
								'register.name_err' | translate
							}}</mat-error>
						</div>
					</div>
					<div class="form-group">
						<label class="text-dark"
							>{{ 'register.phone' | translate }} <span class="label-mandatory"> *</span></label
						>
						<input
							type="tel"
							formControlName="hp"
							class="form-control"
							placeholder="e.g；0123456789"
							[ngClass]="{
								'input-error': firstStepFormControls.hp.touched && firstStepFormControls.hp.errors
							}"
						/>
						<div *ngIf="firstStepFormControls.hp.touched && firstStepFormControls.hp.errors">
							<mat-error *ngIf="firstStepFormControls.hp.errors.required">{{
								'register.phone_req' | translate
							}}</mat-error>
							<mat-error *ngIf="firstStepFormControls.hp.errors.pattern">{{
								'register.phone_valid' | translate
							}}</mat-error>
						</div>
						<p class="text-muted pt-2">{{ 'register.phoneNum-desc' | translate }}</p>
					</div>
					<div class="form-group">
						<label class="text-dark">
							{{ 'register.email' | translate }}<span class="label-mandatory">*</span>
						</label>
						<input
							type="email"
							formControlName="email"
							class="form-control"
							placeholder="{{ 'register.email' | translate }}"
							[ngClass]="{
								'input-error': firstStepFormControls.email.touched && firstStepFormControls.email.errors
							}"
						/>
						<div *ngIf="firstStepFormControls.email.touched && firstStepFormControls.email.errors">
							<mat-error *ngIf="firstStepFormControls.email.errors.required">{{
								'register.email_req' | translate
							}}</mat-error>
							<mat-error *ngIf="firstStepFormControls.email.errors.email">{{
								'register.email_valid' | translate
							}}</mat-error>
						</div>
						<div *ngIf="apiError && apiError.email">
							<mat-error *ngIf="apiError.email">{{ apiError.email }}</mat-error>
						</div>
					</div>
					<div class="form-group mb-2">
						<label class="text-dark"
							>{{ 'register.password' | translate }} <span class="label-mandatory"> *</span></label
						>
						<input
							type="password"
							formControlName="password"
							class="form-control"
							placeholder="{{ 'register.password' | translate }}"
							[ngClass]="{
								'input-error': firstStepFormControls.password.touched && firstStepFormControls.password.errors
							}"
							autocomplete="new-password"
						/>
						<div *ngIf="firstStepFormControls.password.touched && firstStepFormControls.password.errors">
							<mat-error *ngIf="firstStepFormControls.password.errors.required">{{
								'register.password_req' | translate
							}}</mat-error>
							<mat-error *ngIf="firstStepFormControls.password.errors.minlength">{{
								'register.password_valid' | translate
							}}</mat-error>
						</div>
						<div *ngIf="apiError && apiError.password">
							<mat-error *ngIf="apiError.password">{{ apiError.password }}</mat-error>
						</div>
					</div>
					<div class="form-group">
						<input
							type="password"
							formControlName="password_confirmation"
							class="form-control"
							placeholder="{{ 'register.confirm-password' | translate }}"
							[ngClass]="{
								'input-error':
									firstStepFormControls.password_confirmation.touched &&
									firstStepFormControls.password_confirmation.errors
							}"
						/>
						<div
							*ngIf="
								firstStepFormControls.password_confirmation.touched &&
								firstStepFormControls.password_confirmation.errors
							"
						>
							<mat-error *ngIf="firstStepFormControls.password_confirmation.errors.required">
								{{ 'register.password_confirm_req' | translate }}
							</mat-error>
							<mat-error *ngIf="firstStepFormControls.password_confirmation.errors.PasswordValidator">
								{{ 'register.password_confirm_valid' | translate }}
							</mat-error>
						</div>
					</div>
				</form>
				<button
					color="accent"
					class="btn-block"
					mat-flat-button
					matStepperNext
					[disabled]="firstStepForm.invalid"
				>
					{{ 'register.continue' | translate }}
				</button>
			</mat-step>
			<mat-step [stepControl]="secondStepForm">
				<form [formGroup]="secondStepForm">
					<div class="h6 mb-3">{{ 'register.step_2_title' | translate }}</div>
					<div class="form-group">
						<label class="text-dark"
							>{{ 'register.company-name' | translate }} <span class="label-mandatory"> *</span></label
						>
						<input
							type="text"
							formControlName="company_name"
							class="form-control"
							placeholder="{{ 'register.company-name' | translate }}"
							(input)="autoSubdomainName($event)"
							[ngClass]="{
								'input-error':
									secondStepFormControls.company_name.touched && secondStepFormControls.company_name.errors
							}"
							autocomplete="off"
						/>
						<div
							*ngIf="
								secondStepFormControls.company_name.touched && secondStepFormControls.company_name.errors
							"
						>
							<mat-error *ngIf="secondStepFormControls.company_name.errors.required">
								{{ 'register.company-email_req' | translate }}
							</mat-error>
						</div>
					</div>
					<div class="form-group">
						<label class="text-dark"
							>{{ 'register.subdomain' | translate }} <span class="label-mandatory"> *</span></label
						>
						<div class="input-group">
							<input
								type="text"
								formControlName="subdomain"
								class="form-control input-lowercase subdomainInput"
								placeholder="Subdomain"
								[ngClass]="{
									'input-error':
										secondStepFormControls.subdomain.touched && secondStepFormControls.subdomain.errors
								}"
							/>
							<div class="input-group-append">
								<span class="input-group-text">.biztory.com.my</span>
							</div>
						</div>
						<div *ngIf="secondStepFormControls.subdomain.touched && secondStepFormControls.subdomain.errors">
							<mat-error *ngIf="secondStepFormControls.subdomain.errors.required">{{
								'register.subdomain_req' | translate
							}}</mat-error>
							<mat-error *ngIf="secondStepFormControls.subdomain.errors.pattern">{{
								'register.subdomain_valid' | translate
							}}</mat-error>
						</div>
						<div *ngIf="apiError && apiError.subdomain">
							<mat-error *ngIf="apiError.subdomain">{{ apiError.subdomain }}</mat-error>
						</div>
						<div *ngIf="validating">loading...</div>
						<p class="text-muted pt-2">{{ 'register.subdomain_hint' | translate }}</p>
					</div>
				</form>
				<div class="form-group">
					<button
						color="accent"
						class="btn-block"
						mat-flat-button
						(click)="onSubmit()"
						[disabled]="secondStepForm.touched && secondStepForm.invalid"
					>
						{{ 'register.activate' | translate }}
					</button>
					<p class="cardMargin text-muted">
						{{ 'register.accept-tof' | translate }}
						<a class="tof" href="http://www.biztory.com.my/term-of-service" target="_blank">
							{{ 'register.tof' | translate }}
						</a>
					</p>
				</div>
			</mat-step>
		</ng-container>
	</mat-stepper>
</div>
<div class="loadingContainer" *ngIf="progress != 0 && progress != 100">
	<div class="card">
		<div class="card-body">
			<img class="img-responsive" src="assets/image/loading.gif" placeholder="Biztory Loading .gif file" />
		</div>
		<div class="card-body">
			<p>Tips:</p>
			<h3 *ngIf="text_num">{{ 'register.rand_text_' + text_num + '' | translate }}</h3>
		</div>
	</div>
</div>

<a class="whatsapp-btn" href="{{ 'register.whatsappMsg' | translate }}" target="_blank">
	<img src="assets/image/whatsapp.png" class="img-responsive" width="50px" />
</a>
